import Vue from 'vue'
import Vuex from 'vuex'
import catalog from './module/catalog'
import business from './module/business'
import cart from './module/cart'
import feedback from './module/feedback'
import user from './module/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: user,
    catalog: catalog,
    business: business,
    cart: cart,
    feedback: feedback
  }
})
